import { useState, useEffect } from "react";

// In-memory store: state survives in-app navigation (tab/module switches) but is
// wiped on a full browser refresh — refresh is the intentional "reset the system" action.
const memStore = {};

export function usePersistedState(key, initial) {
  const [state, setState] = useState(() => (key in memStore ? memStore[key] : initial));
  useEffect(() => { memStore[key] = state; }, [key, state]);
  return [state, setState];
}

export default usePersistedState;
